module.exports = __webpack_public_path__ + "sardinia.svg?01702ed5d4a1131f02ac0a715b321b08";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/sardinia.svg
// module id = 284
// module chunks = 10